import { render } from "./BaseAutocomplete.vue?vue&type=template&id=22f68cda&scoped=true"
import script from "./BaseAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseAutocomplete.vue?vue&type=script&lang=js"

import "./BaseAutocomplete.vue?vue&type=style&index=0&id=22f68cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f68cda"]])

export default __exports__